"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var passwordMatch = function regexMatch(value, options) {
  if (!value || !value.match(/^(?=.*\d+)(?=.*[a-zA-Z])[0-9a-zA-Z!@#$%]{8,30}$/)) {
    return options.message || 'Password must contain 8 characters with at least one letter and one number; special characters can only include !, @, #, $ or %.';
  }
};
var validators = {
  email: [],
  password: [passwordMatch],
  confirmPassword: [passwordMatch]
};
var _default = validators;
exports.default = _default;
